import React, { useEffect } from "react"
import { powerBIClient, ssr } from "../../lib/powerBI"

const PowerBIEmbed = (props) => {
  const { model } = props

  useEffect(() => {
    const { models } = powerBIClient

    const embedConfig = {
      type: "report",
      id: model.embedToken.id,
      embedUrl: "https://app.powerbi.com/reportEmbed",
      accessToken: model.embedToken.token,
      tokenType: models.TokenType.Embed,
      permissions: models.Permissions.Read,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: true,
      },
    }

    const embedElement = document.querySelector("#bi-embed-root")
    window.report = window.powerbi.embed(embedElement, embedConfig)
  }, [])

  if (ssr) {
    return null
  }

  return (
    <div className="embed-container">
      <div id="bi-embed-root" />
    </div>
  )
}

export default PowerBIEmbed
